<script>
	import { yesNoOptions } from "../config";
	import RadioGroup from "./RadioGroup.svelte";

	export let label = "";
	export let name;
	export let value;

	export let orientation = "horizontal";

	export let required = null;
	export let disabled = null;
</script>

<RadioGroup
	{name}
	bind:value
	optionList={yesNoOptions}
	labelProperty="label"
	valueProperty="value"
	{label}
	{required}
	{disabled}
	{orientation}
	on:change
></RadioGroup>
